import React from 'react';
import { DocumentScanner } from '@mui/icons-material';
import SpaceUsageCard from "../deprecatedUikit/SpaceUsageCard/SpaceUsageCard";
import {Box} from "@mui/material";
import { FormattedSubscriptionItem } from "./formatSubscriptions";

const dataFields = ["feeType", "createdOn","createdBy", "reason", "amount", "paymentSource", "active"]

interface PartnerSubscriptionsMapProps {
  subscriptions: FormattedSubscriptionItem[];
}

const PartnerSubscriptionsMap = ({ subscriptions }: PartnerSubscriptionsMapProps) => {

  const actionItems = [
    {
        icon: <DocumentScanner fontSize="medium" color="primary" />,
        label: 'View Invoice',
        onClick: (item?: FormattedSubscriptionItem) => {
          if (item) {
            window.open(`/supplier-subscriptions/${item.id}`)
          }
        },
    },]

  return (
    <Box mt={4} sx={{
      ...(subscriptions.length === 0) && {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '50vh'
      }
    }}>
      {subscriptions.map(item => (
        // @ts-expect-error SpaceUsageCard's `data` is typed as ICardData ({label, value}) but actually accepts any record
        <SpaceUsageCard key={item.id} data={item} styles={{ mb:2, width:'100%'}} fields={dataFields} emailFieldName="createdBy" hasAction={true} actionItems={actionItems} />
      ))}
    </Box>
  )
};

export default PartnerSubscriptionsMap;
